import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react';
import React from 'react';

interface ConfirmModalProps {
  visible: boolean;
  title: string;
  message: string;
  confirmText: string;
  confirmColor: 'danger' | 'warning' | 'primary' | 'success';
  loading?: boolean;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  visible,
  title,
  message,
  confirmText,
  confirmColor,
  loading = false,
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  return (
    <CModal visible={visible} onClose={onCancel}>
      <CModalHeader>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>{message}</CModalBody>
      <CModalFooter>
        <CButton
          color="secondary"
          onClick={onCancel}
          disabled={loading}
          style={{ cursor: 'pointer' }}
        >
          {cancelText}
        </CButton>
        <CButton
          color={confirmColor}
          onClick={onConfirm}
          disabled={loading}
          style={{ cursor: 'pointer' }}
        >
          {loading ? 'Processing...' : confirmText}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
